module.exports = ['$rootScope', function ($rootScope) {
    return {
        restrict: 'AE',
        require: 'ngModel',
        templateUrl: '/static/partials/components/pd_color_picker.html',
        replace: true,
        scope: {
            ngDisabled: '='
        },
        link: function (scope, element, attrs, ngModel) {


            scope.colors = $rootScope.colorPalette || [
                "#23719F", "#34A7EB", "#5B90AF", "#7AC2EB",
                "#184D6C", "#53C593", "#AC373A", "#F84F54",
                "#BA7375", "#F89A9D", "#EBE828", "#6B6A12",
                "#B8B61F", "#392E6E", "#7C64ED", "#973CBA",
                "#816F87", "#BA923C", "#F0DFA1", "#3A2E13"
            ];

            ngModel.$render = function () {
                scope.selectedColor = ngModel.$modelValue;
            };

            scope.setColor = function(color){
                if(scope.ngDisabled) return;

                ngModel.$setViewValue(color);
                ngModel.$render();
            };
        }
    };
}];